<script>
import { computed } from 'vue'
import { get } from 'vuex-pathify'

export default {
	inheritAttrs: false,
	data() {
		return {
			financiadores: [],
			loadingFinanciadores: true,
			financiadorKey: null,
			NroAfiliado: '',
			CodSeguridad: '',
			NroRecetaElectronica: '',
			recetas: [],
			submitting: false,
			loading: true,
			pickupPoints: [],
			selectedPickupPointId: null,
			removeLoading: null,
			submitSuccess: false,
		}
	},
	computed: {
		canSubmitReceta() {
			return this.financiadorKey && this.NroAfiliado && this.NroRecetaElectronica && this.CodSeguridad
		},
		selectedPickupPoint() {
			return this.selectedPickupPointId
				? this.pickupPoints.find((pp) => pp.id == this.selectedPickupPointId)
				: null
		},
		order: get('cart/order'),
		someProductInCart() {
			return !!this.order?.items.some((item) => item.customization?.key == 'recetadigital')
		},
	},
	provide() {
		return {
			getPickupPoints: () => this.pickupPoints,
			getSelectedPickupPoint: () => this.selectedPickupPoint,
		}
	},
	methods: {
		loadFinanciadores() {
			this.$shopApi.get('/recetadigital/financiadores', {
				loading: (v) => (this.loadingFinanciadores = v),
				onSuccess: ({ data }) => {
					this.financiadores = data.financiadores
				},
			})
		},
		loadRecetas() {
			this.$shopApi.get('/recetadigital/recetas', {
				loading: (v) => (this.loading = v),
				onSuccess: ({ data }) => {
					this.recetas = data.recetas || []
				},
			})
		},
		loadPickupPoints() {
			this.$shopApi.get('/recetadigital/pickup-points', {
				loading: false,
				onSuccess: ({ data }) => {
					this.pickupPoints = data.pickupPoints || []
					if (this.pickupPoints.length == 1) {
						this.selectedPickupPointId = this.pickupPoints[0].id
					}
				},
			})
		},
		async submitReceta() {
			let recetaId
			await this.$shopApi.post('/recetadigital/recetas', {
				loading: (v) => (this.submitting = v),
				data: {
					financiadorKey: this.financiadorKey,
					NroAfiliado: this.NroAfiliado,
					CodSeguridad: this.CodSeguridad,
					NroRecetaElectronica: this.NroRecetaElectronica,
				},
				onSuccess: async ({ data }) => {
					await this.loadRecetas()
					this.NroRecetaElectronica = null
					this.CodSeguridad = null
					recetaId = data.recetaId
				},
			})

			this.$nextTick(() => {
				this.submitSuccess = true
				this.$nextTick(() => {
					setTimeout(() => {
						this.$vuetify.goTo(`#receta-${recetaId}`, { offset: 120, duration: 750 })
					}, 1000)
				})
			})
		},
		removeReceta(receta) {
			this.$shopApi.delete(`/recetadigital/recetas/${receta.id}`, {
				loading: (v) => (this.removeLoading = v ? receta.id : null),
				onSuccess: async () => {
					this.recetas = this.recetas.filter((r) => r.id !== receta.id)
				},
			})
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.loadFinanciadores()
			this.loadRecetas()
			this.loadPickupPoints()
		})
	},
}
</script>

<template>
	<Container class="py-4 d-flex flex-column flex-md-row" style="gap: 12px" id="receta-digital-manager">
		<div class="flex-shrink-0" :style="$b({ mt: { width: '100%' }, _: { width: '320px' } })">
			<div
				:style="$b({ m: { width: '100%' }, t: { width: '80%', margin: '0 auto' }, _: { width: '100%' } })"
				class="px-4 py-8 rounded-lg"
				style="background: rgba(0, 0, 0, 0.05)"
			>
				<div class="d-flex align-center pb-4">
					<v-icon left color="success">mdi-plus</v-icon>
					<b class="font-3">Cargar Receta Digital</b>
				</div>
				<div class="d-flex flex-column" style="gap: 12px">
					<Select
						:items="financiadores"
						v-model="financiadorKey"
						label="Obra Social / Prepaga"
						item-text="displayName"
						item-value="key"
						:loading="loadingFinanciadores"
					/>
					<TextField type="tel" v-model="NroAfiliado" label="Nro. de Afiliado" />
					<TextField type="tel" v-model="NroRecetaElectronica" label="Nro. de Receta" />
					<TextField type="tel" v-model="CodSeguridad" label="Token / Código de Seguridad" />
					<Button
						class="mt-4"
						@click="submitReceta"
						color="success"
						:loading="submitting"
						:disabled="!canSubmitReceta"
					>
						<v-icon small left>mdi-magnify</v-icon> Cargar Receta
					</Button>
				</div>
			</div>
			<div class="pt-6 px-4 px-md-2">
				<div class="pb-2" style="border-bottom: 1px solid #bbb">
					<b class="font-2">Verificar disponibilidad en Sucursales</b>
				</div>
				<div class="pb-sm-0 pt-6">
					<Select
						class="pp-select"
						:items="[{ id: null, name: 'Todas las sucursales con stock disponible' }, ...pickupPoints]"
						v-model="selectedPickupPointId"
						label="Sucursal"
						item-text="name"
						item-value="id"
						:loading="!pickupPoints.length"
						outlined
					>
						<template #selection="{ item }">
							<div class="d-flex flex-column justify-center pa-3" style="min-height: 57px">
								<div class="font-weight-bold">{{ item.name }}</div>
								<div class="d-flex align-center pt-1" v-if="item.id">
									<v-icon left small class="flex-shrink-0">mdi-map-marker</v-icon>
									<div class="grey--text text--darken-1 font-1">
										{{ item.street }} {{ item.streetNumber }}, {{ item.city }},
										{{ item.zipcode.state.name }}
									</div>
								</div>
								<div class="d-flex align-center" v-if="item.id">
									<v-icon left small class="flex-shrink-0">mdi-clock</v-icon>
									<div class="grey--text text--darken-1 font-1">
										{{ item.openingHours }}
									</div>
								</div>
							</div>
						</template>
						<template #item="{ item }">
							<div
								class="d-flex flex-column justify-center pa-3 w100"
								style="min-height: 57px; border-bottom: 1px solid #ddd"
							>
								<div class="font-weight-bold">{{ item.name }}</div>
								<div class="d-flex align-center pt-1" v-if="item.id">
									<v-icon left small class="flex-shrink-0">mdi-map-marker</v-icon>
									<div class="grey--text text--darken-1 font-1">
										{{ item.street }} {{ item.streetNumber }}, {{ item.city }},
										{{ item.zipcode.state.name }}
									</div>
								</div>
								<div class="d-flex align-center" v-if="item.id">
									<v-icon left small class="flex-shrink-0">mdi-clock</v-icon>
									<div class="grey--text text--darken-1 font-1">
										{{ item.openingHours }}
									</div>
								</div>
							</div>
						</template>
					</Select>
					<div class="pt-8 grey--text text--darken-1 font-weight-medium">Disponible solo en CABA</div>
				</div>
			</div>
		</div>
		<div class="w100 px-4 py-4 py-md-8">
			<div class="pb-2 mb-8" style="border-bottom: 1px solid #bbb">
				<b class="font-3">Tus Recetas</b>
			</div>
			<div class="pa-8 d-flex justify-center" v-if="loading">
				<v-progress-circular indeterminate size="80" width="8" />
			</div>
			<div v-else-if="!recetas.length" class="pa-8 text-center">
				<i class="grey--text">No has cargado ninguna receta aún</i>
			</div>
			<div class="d-flex flex-column" style="gap: 24px" v-else>
				<!-- Lista de recetas -->
				<RecetaDigitalRecetaItem
					v-for="receta of recetas"
					:key="receta.id"
					:receta="receta"
					@remove="removeReceta(receta)"
					:remove-loading="removeLoading == receta.id"
				/>
			</div>
			<div
				class="w100 py-4 mt-8 d-flex align-center justify-center justify-sm-end"
				style="gap: 24px; border-top: 1px solid #bbb"
				v-if="recetas.length"
			>
				<Button text color="cta" @click="$shop.showCart()" :disabled="!someProductInCart">
					Ver carrito <v-icon right>mdi-cart</v-icon>
				</Button>
				<Button color="cta" :large="!$b.m" @click="$shop.goCheckout()" :disabled="!someProductInCart">
					Finalizar compra <v-icon right>mdi-arrow-right</v-icon>
				</Button>
			</div>
		</div>
		<v-snackbar :timeout="3000" v-model="submitSuccess" shaped bottom right color="success">
			<v-icon left>mdi-check-circle</v-icon> <b>Receta cargada con éxito</b>
		</v-snackbar>
	</Container>
</template>

<style lang="scss" scoped>
.pp-select ::v-deep input {
	display: none;
}
</style>

